import { useLocation } from '@melio/platform-utils';
import type { Plan } from '@melio/subscriptions-api';
import { useSearchParams } from 'react-router-dom';

type SseWizardParamsProps = {
  firstPaidPlan?: Plan;
};

export const useWizardParams = ({ firstPaidPlan }: SseWizardParamsProps) => {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();

  const { returnUrl } = (state as { returnUrl?: string }) || {};
  const planId = searchParams.get('planId') || firstPaidPlan?.id;

  return { returnUrl, planId };
};
